import { useEffect, useState } from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getModuleByIdStart } from "../../../../Store/Slices/formSlice";

const ProbabilityMappingProperty = ({ moduleStoreData, showProbabilityModal, setShowProbabilityModal }) => {
    let { id } = useParams();
    const dispatch = useDispatch();
    let getCreateUpdateListByID = useSelector((state) => state?.forms);
    let dealCategory = ['Open', 'Closed Won', 'Closed Lost'];
    let stages = useSelector((state) => state.probability.stages);
    if (getCreateUpdateListByID?.modules?.[0]?.stageProbability)
        stages = getCreateUpdateListByID?.modules?.[0]?.stageProbability;

    let [stageProbability, setStageProbability] = useState(stages);

    const getForecastOptions = (dealCategory) => {
        if (dealCategory === "Closed Won") return ["Closed"];
        if (dealCategory === "Closed Lost") return ["Omitted"];
        return ["Pipeline", "Base Case", "Committed"];
    };

    useEffect(() => {
        if (id) {
            dispatch(getModuleByIdStart(id));
        }
    }, [])

    useEffect(() => {
        if (getCreateUpdateListByID?.modules && getCreateUpdateListByID?.modules?.[0]?.plural_form === "Deals") {
            dispatch({ type: "SET_PROBABILITY_STAGES", payload: getCreateUpdateListByID?.modules?.[0]?.stageProbability || [] });
        }
    }, [getCreateUpdateListByID?.modules]);

    const handleChange = (index, key, value) => {
        setStageProbability((prev) =>
            prev.map((row, i) => {
                if (i !== index) return row;
                const newRow = { ...row, [key]: value };
                if (key === "dealCategory") {
                    newRow.forecastCategory = getForecastOptions(value)[0];
                }
                return newRow;
            })
        );
    };

    // const handleChange = (e, i) => {
    //     let { name, value } = e.target
    //     setStageProbability((prev) =>
    //         prev.map((item, index) =>
    //             index === i ? { ...item, [name]: name === "probability" ? Number(value) : value } : item
    //         )
    //     );
    //     if (name === 'dealCategory') {
    //         debugger
    //     }
    // };

    const handleDone = () => {
        dispatch({ type: "SET_PROBABILITY_STAGES", payload: stageProbability });
        setShowProbabilityModal(false)
    }

    const sanitizeProbability = (raw) => {
        raw = raw.replace(/\D+/g, "");
        if (raw === "") return 0;
        raw = raw.replace(/^0+(?=\d)/, "");
        let num = parseInt(raw, 10);
        if (isNaN(num)) num = 0;
        if (num < 0) num = 0;
        if (num > 100) num = 100;
        return num;
    };

    return (
        <>
            <Modal show={showProbabilityModal} onHide={() => setShowProbabilityModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Stage-Probability Mapping</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <div className="mb-3">
                                <label htmlFor="fieldInput" className="form-label">Field Label</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="fieldInput"
                                    placeholder="Enter field label"
                                    value="Stage"
                                    disabled
                                />
                            </div>
                        </Row>
                        <Row>
                            <div className="col-12">
                                <div className="tbl-container rounded-table">
                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Stage Name</th>
                                                    <th>Probability (%)</th>
                                                    <th>Deal Category</th>
                                                    <th>Forecast Category</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {stageProbability?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="text"
                                                                className="form-control mail-field"
                                                                value={data?.stageName}
                                                                name="stageName"
                                                                onChange={(e) => handleChange(i, "stageName", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {/* <input type="number"
                                                                className="form-control mail-field"
                                                                value={data?.probability}
                                                                name="probability"
                                                                onChange={(e) => handleChange(i, "probability", e.target.value)}
                                                            /> */}
                                                            <input
                                                                className="form-control mail-field"
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={String(data.probability)}
                                                                onChange={(e) => {
                                                                    const num = sanitizeProbability(e.target.value);
                                                                    handleChange(i, "probability", num);
                                                                }}
                                                                onBlur={(e) => {
                                                                    if (e.target.value.trim() === "") handleChange(i, "probability", 0);
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <select className="form-select"
                                                                name="dealCategory"
                                                                value={data?.dealCategory}
                                                                onChange={(e) => handleChange(i, "dealCategory", e.target.value)}
                                                            >
                                                                {dealCategory?.map((deal, i) => (
                                                                    <option key={i} value={deal}>{deal}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-select"
                                                                name="forecastCategory"
                                                                value={data?.forecastCategory}
                                                                onChange={(e) => handleChange(i, "forecastCategory", e.target.value)}
                                                            >
                                                                {getForecastOptions(data.dealCategory)?.map((forecast) => (
                                                                    <option key={forecast} value={forecast}>{forecast}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowProbabilityModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => handleDone()}>
                        Done
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ProbabilityMappingProperty;